import React from 'react';
import { useParams } from 'react-router-dom';
import './pressRelease.css';
import caseStudyData from './caseStudyData';

/* SWIPER */
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const PressReleaseTemplate = () => {

  const { slug } = useParams();
  const data = caseStudyData[slug];

  if (!data) return <h1>Case Study Not Found</h1>;

  return (

    <div className="press-page">

      {/* HERO */}

      <section className="press-hero">

        {/* LEFT */}
        <div className="press-left">

          <div className="press-badge">{data.badge}</div>

          <h1>{data.title}</h1>

          <p className="press-desc">{data.description}</p>

          {/* INFO */}
          <div className="info-wrapper">

            <div className="info-box">
              <div className="info-icon">👤</div>
              <div>
                <h4>Person</h4>
                <p>{data.person}</p>
                <span>{data.role}</span>
              </div>
            </div>

            <div className="info-box">
              <div className="info-icon">📄</div>
              <div>
                <h4>Publication</h4>
                <p>{data.publication}</p>
                <span>{data.issue}</span>
              </div>
            </div>

          </div>

          {/* TESTIMONIAL (MOVED HERE) */}
          <div className="testimonial-box">
            <div className="quote-mark">“</div>
            <p>{data.quote}</p>
            <h4>— {data.author}</h4>
          </div>

        </div>

        {/* RIGHT */}
        <div className="press-right">

          <Swiper
            modules={[Navigation]}
            navigation={true}
            spaceBetween={20}
            slidesPerView={1}
            className="press-swiper"
          >
            {data.heroImages.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt="" className="swiper-image" />
              </SwiperSlide>
            ))}
          </Swiper>

        </div>

      </section>

      {/* PROCESS + IMPACT */}

      <section className="process-section">

        {/* PROCESS */}
        <div className="process-left">

          <h2>Our Work Process</h2>

          <div className="process-grid">
            {data.process.map((item, index) => (
              <div className="process-card" key={index}>
                <div className="process-icon">{index + 1}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

        </div>

        {/* IMPACT */}
        <div className="impact-box">

          <h2>Impact</h2>

          <ul>
            {data.impacts.map((item, index) => (
              <li key={index}>✓ {item}</li>
            ))}
          </ul>

        </div>

      </section>

    </div>
  );
};

export default PressReleaseTemplate;